import { AuthType } from '../../../lib/enums';
import { useAuthType } from '../../../lib/providers/authTypeState';

interface ShowSalariesInMyRegionButtonProps {}

const ShowSalariesInMyRegionButton: React.FC<
  ShowSalariesInMyRegionButtonProps
> = () => {
  const { setAuthType } = useAuthType();
  return (
    <button
      onClick={() => {
        setAuthType(AuthType.Login);
      }}
      className="my-4 flex mx-auto items-center hover:bg-white hover:text-primary border-2 border-save-button justify-center py-4 w-[250px] max-w-full font-base rounded-full font-bold bg-save-button text-white row-start-5 col-start-1 col-end-5"
    >
      Show Salaries for my Area
    </button>
  );
};

export default ShowSalariesInMyRegionButton;
